import { requestApi } from './Api';

export const getQuotes = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/patient/quote/read',
    params
  });

export const createQuote = (navigate, params) =>
  requestApi({
    navigate,
    url: '/api/patient/quote/create',
    params
  });
